import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { BiMoneyWithdraw } from "react-icons/bi";
import { AddLocation } from "../components/add_location";
import { MdOutlineWarehouse } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { VscDiffAdded } from "react-icons/vsc";


export default function ManageStore() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [pageData, setPageData] = useState({});
    const [itemUpdating, setItem] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    useEffect(() => {
        setOffset(0);
        searchData();
    }, [formFields?.category, formFields?.order])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        // Object.entries(formFields).forEach(([key, value]) => {
        //   formData.append(key, value);
        // });
        formData.append('offset', offset);
        if (formFields?.category !== undefined) {
            formData.append('category', formFields?.category);
        }
        if (formFields?.order !== undefined) {
            formData.append('order', formFields?.order);
            formData.append('order_by', formFields?.order_by);
        }
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_locations.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData(response.data)
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function searchData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', 0);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_locations.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData(response.data)
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showLocationModal &&
            <AddLocation 
                setShowLocationModal={setShowLocationModal}
            />
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="gap-y-2 md:gap-y-0 flex flex-col mb-5 md:flex-row md:items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'My Outlets'}</h2>
                <div className="rounded-xl border p-2 flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <button onClick={() => setShowLocationModal(true) } className="gap-x-2 bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                        <VscDiffAdded />
                        <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Add New Location</span>
                    </button>
                </div>
            </div>
            <div className="gap-y-2 md:gap-y-0 flex flex-col mt-3 md:mt-7 md:flex-row md:items-center justify-end">
                <div className="min-w-[30%] flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <div className="w-full flex items-center justify-between border rounded-xl p-1">
                        <input
                            type="text"
                            placeholder="Enter name"
                            className="w-full bg-transparent focus:outline-none text-gray-700 px-2"
                            value={formFields?.search}
                            onChange={(e) => {setFormFields({...formFields, search: e.target.value}); }}
                        />
                        <button onClick={() => formFields?.search?.length > 0 ? searchData() : getData() } className="hover:opacity-[0.8] bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-3 rounded-xl shadow-md shrink-0 text-sm md:text-md">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price"><IoSearch /></span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-x-1">
                                Name
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'name', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "name" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'name', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "name" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Stock Value
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'stock_value', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "stock_value" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'stock_value', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "stock_value" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Sale Value
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'sale_value', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "sale_value" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'sale_value', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "sale_value" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Staff Count
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Domain</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Country</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600"><div className="flex items-center gap-1">Manage</div></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="max-w-[3rem] px-2 py-2 font-semibold">
                                    {row.name}
                                </td>
                                <td className="px-2 py-2">
                                    {row.stock_value}
                                </td>
                                <td className="px-2 py-2">
                                    {row.sale_value}
                                </td>
                                <td className="px-2 py-2">
                                    {row.staff_count}
                                </td>
                                <td className="px-2 py-2">
                                    {row.domain}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.currency}{", "}{row.country}
                                </td>
                                <td className="px-2 py-2">
                                    <div className="flex items-center flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div className="">
                                            <a onClick={() => navigate(`/dashboard/store/staff/${row.location_id}`, {state: { locations: bookingList }})} className="cursor-pointer underline text-secondary text-sm font-medium p-1">Staff</a>
                                            <a onClick={() => window.open(row.domain, '_blank')} className="cursor-pointer underline text-[#037684] text-sm font-medium p-1">View</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
